var EvaluationService = require('services/evaluation-service');

var SurveyService = function() {
  this.getRedirectUrlForCurrentPage = function(){
    var currentPage = EF.module.currentActivity.currentPage;
    var redirectUrl = "#" + currentPage.path();
    return redirectUrl;
  };

  this.triggerSurvey = function(blockView){
    var redirectUrl = this.getRedirectUrlForCurrentPage();
    var data = {
      event_type: 'survey-initialized',
      redirectUrl: redirectUrl,
      slug: blockView.model.get('slug')
    };
    window.parent.postMessage(data, '*');
  };

  this.userHasCompletedSurvey = function(courseSlug){
    return EvaluationService.userHasCompletedEvaluation(courseSlug);
  };

  this.getSurvey = function(blockView){
    let surveyResponseModel = EF.responseSet.models.find((model) => { return model.get('evaluation').slug == blockView.model.get('slug'); });
    let survey = _.pick(surveyResponseModel.attributes, ['slug', 'answers', 'sections', 'questions']);
    var responseSet = EvaluationService.getResponseSetFromModel(blockView.model.get('slug'));
    blockView.model.set('responseSet', surveyResponseModel);
    // sections is not set on the survey model for some reason
    // this has to be handled here or in the template
    blockView.model.set('translate', false);
    blockView.model.get('survey').set('sections', surveyResponseModel.get('sections'));
    blockView.render();
  };

  this.saveSurveyResponse = function(blockView, dataset){
    let surveyResponseModel = EF.responseSet.models.find((model) => { return model.get('evaluation').slug == blockView.model.get('slug'); });
    let options = surveyResponseModel.save([{question_id: dataset.questionId, answer_id: dataset.answerId}]);
    return Backbone.Model.prototype.save.call(surveyResponseModel, options.attrs, options);
  };
};

module.exports = new SurveyService();
